export default "__VITE_ASSET__17621100__"